import React from 'react';
import { SharedUiThemeProvider, ErrorState } from '@harver/shared-ui';

import { GlobalStyle } from '../GlobalStyle';
import { defaultTheme } from '../../branding/theme';

export const ErrorPage = () => {
    return (
        <SharedUiThemeProvider theme={defaultTheme}>
            <GlobalStyle />
            <ErrorState testId="branding.errorScreen" onReloadClick={() => window.location.reload()} />
        </SharedUiThemeProvider>
    );
};
